import $ from 'jquery';
const ELEMENT_SELECTOR = '.js__collection-max-items-count';
const ADD_BUTTON = '.js__add-action';
const DELETE_BUTTON = '.js__delete-action';
const COLLECTION_ITEM = '.js__collection-item';
export class CollectionMaxItems {
    static init($root = $('body')) {
        const $collection = $root.find(ELEMENT_SELECTOR);
        if (!$collection.length) {
            return;
        }
        $root.on('click', `${ADD_BUTTON}`, e => {
            const $collection = $(e.currentTarget).closest(ELEMENT_SELECTOR);
            this.recalculateItemsCount($collection);
            $collection
                .find(DELETE_BUTTON)
                .last()
                .on('click', e => {
                const $collection = $(e.currentTarget).closest(ELEMENT_SELECTOR);
                this.recalculateItemsCount($collection);
            });
        });
    }
    static recalculateItemsCount($collection) {
        setTimeout(() => {
            const itemsCount = $collection.find(COLLECTION_ITEM).length;
            const maxItemsCount = $collection.data('max-count');
            const isLimitReached = itemsCount >= maxItemsCount;
            const $addButton = $collection.find(ADD_BUTTON);
            if (isLimitReached) {
                $addButton.hide();
            }
            else {
                $addButton.show();
            }
        });
    }
}
